module.exports = __webpack_public_path__ + "static/media/ios-boat.e08fdee3.svg";